import RebateReview from './index';

export default { path: '/home/rebateReview', component: RebateReview };
